import Backend from './Backend';
import { stringify } from 'query-string';

export default (url, rssUrl) => {

  const params = {
    headers: { 'Accept': 'application/json' }
  }

  const queryParams  = { url: rssUrl };

  return Backend.abortableGet.call(null, `${url}?${stringify(queryParams)}`, params);
};
